// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2mkh5","alertIcon":"ConfirmModal_alertIcon__1F7Lj"};